import {combineReducers} from "redux";
import navigation from './navigation';
import clients from './clients';
import newsletters from './newsletters';
import search from './search';
import articles from './articles';
import styles from './styles';
import { connectRouter } from 'connected-react-router';

// https://redux.js.org/api/combinereducers
// https://redux.js.org/recipes/structuring-reducers/using-combinereducers

const rootReducer = (history) => {
    return combineReducers({
        router: connectRouter(history),
        navigation,
        clients,
        newsletters,
        search,
        articles,
        styles
    });
}

export default rootReducer;
